import axios from "axios";
import { NewRepository, Repository } from "./repository";
const resource = "Counsel";
const counselRepo = {
     registerCounsel
};

function registerCounsel(payLoad) {
    return Repository().post(`${resource}/register`, payLoad);
}


export default counselRepo;